<template>
  <div>
    <Toolbar >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-format-color-fill</v-icon>{{$t('profile.material.subsupplies')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-materialsupplysub-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.material.input') }}</strong></td>
              <td>
                {{ $n(item['input']) }}              </td>

              <td><strong>{{ $t('profile.material.medium') }}</strong></td>
              <td>
                                    {{ item['medium'].name }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.material.feedspec') }}</strong></td>
              <td>
                                    {{ item['feedSpec'].name }}
              </td>


            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'MaterialSupplySub';

export default {
  name: 'MaterialSupplySubShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('materialsupplysub', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('materialsupplysub', ['find'])
  },
  methods: {
    ...mapActions('materialsupplysub', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
